import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateCommissionListing from '@/modules/promotion/components/CreateCommission/components/CreateCommissionListing'

function CreateCommissionPage() {
	return (
		<PageContainer>
			<CreateCommissionListing />
		</PageContainer>
	)
}

const GuardedCreateCommissionPage = withUserPermission(CreateCommissionPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_COMMISSION_CASHBACK],
})

export default GuardedCreateCommissionPage
